import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { DisclosureModule } from '@ddt-web/disclosure';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { MvMarketViewsComponent } from './components';

@NgModule({
	imports: [CommonModule, CwpNgFrameworkModule, GenericDirectivesModule, DisclosureModule, SharedModule, AnalyticsModule],
	declarations: [MvMarketViewsComponent],
	exports: [MvMarketViewsComponent]
})
export class MarketViewModule { }
